/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateResourceRequest
 */
export interface CreateResourceRequest {
	/**
	 * RID of the container resource
	 * @type {string}
	 * @memberof CreateResourceRequest
	 */
	containerRID: string;
	/**
	 * Resource metadata
	 * @type {object}
	 * @memberof CreateResourceRequest
	 */
	data: object;
	/**
	 * RID of the resource that invoked this request (e.g. a user, a solution, etc.)
	 * @type {string}
	 * @memberof CreateResourceRequest
	 */
	sourceRID?: string;
}

/**
 * Check if a given object implements the CreateResourceRequest interface.
 */
export function instanceOfCreateResourceRequest(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'containerRID' in value;
	isInstance = isInstance && 'data' in value;

	return isInstance;
}

export function CreateResourceRequestFromJSON(json: any): CreateResourceRequest {
	return CreateResourceRequestFromJSONTyped(json, false);
}

export function CreateResourceRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateResourceRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		containerRID: json['containerRID'],
		data: json['data'],
		sourceRID: !exists(json, 'sourceRID') ? undefined : json['sourceRID'],
	};
}

export function CreateResourceRequestToJSON(value?: CreateResourceRequest | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		containerRID: value.containerRID,
		data: value.data,
		sourceRID: value.sourceRID,
	};
}
